<template>
  <section id="slideshow">
    <div id="pinContainer">
      <div id="slideContainer">
        <section class="panel">
          <div class="panel_container">
            <h3>La <span>Méta</span><span>Kiné</span><span>Biologie</span> (MKB)</h3>
            <prismic-rich-text :field="metadescr" />
          </div>
        </section>
        <section class="panel">
          <div class="panel_container">
            <h3><span>Access</span><span>Bars</span></h3>
            <prismic-rich-text :field="accessdescr" />
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Slideshow",
  props: {
    metadescr: Array,
    accessdescr: Array
  },
  data () {
    return {
      width: 100,
    }
  },

  computed: {
    scrollContainer () {
      return (this.info.container === window) ? 'window' : this.info.container.tagName
    }
  },

  methods: {
    updateInfo () {
      this.info = this.$scrollmagic.info()
    },

    handleScroll (evt) {
      this.updateInfo()
    }
  }
}
</script>

<style lang="css">
#slideshow {
    width: 100%;
    margin-top: 2em;
    margin-bottom: 7em;
}

.panel_container {
    padding: 3em;
    text-align: left;
    height: 100%;
}

.panel_container > div {
    font-size: 120%;
     font-family: "Quintessential";
}

.panel_container > h3 {
    font-family: "Quintessential";
    max-width: 100%;
    font-size: 2em;
    color: #4B4636;
}

.panel_container > div > h3:first-of-type, .panel_container > div > h2:first-of-type, .panel_container > div > h4:first-of-type {
    margin-top: 3em;
}

#pinContainer {
    max-width: 100%!important;
    height: auto!important;
    overflow: hidden;
    -webkit-perspective: 1000;
            perspective: 1000;
    text-align: center;
    color: rgb(107, 107, 107);
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    background: white;
}
#slideContainer {
    width: 100%; /* to contain 2 panels, each with 100% of window width */
    height: auto;
}
.panel {
    height: auto!important;
    width: 100%; /* relative to parent -> 50% of 200% = 100% of window width */
    float: left;
    margin: auto;
}

@media screen and (max-width: 900px) {

    .panel_container {
        padding: 0 2em;
    }
}
</style>